import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Image from 'next/image'
import Box from '@mui/material/Box'
import { RegularSection, ColorTitle } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'

interface Card {
    icon?: string
    title?: string
}

interface Content {
    title?: string
    cards?: Card[]
}

interface S3_about_3Props {
    content?: Content
    blockName?:string
}

const Index = (props: S3_about_3Props) => {
    const { content = {} } = props
    const { title, cards = [] } = content
    return (
        <RegularSection aria-label='S3_about_3' >
            <Grid
                container
                spacing={4}
            >
                <Grid size={12}>
                    <ColorTitle title={title} colorFrom={0} textAlign='start'/>
                </Grid>

                {cards.map((card, idx) => {
                    const { src } = getImageData(card?.icon)
                    return (
                    <Grid
                        size={{ xs: 12, md: 6, lg: 3 }}
                        key={'S3_about_3' + idx}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            borderRadius: 5,
                            gap: 2,
                            border: '1px solid var(--primary-color)',
                            p: 4,
                        }}
                    >
                        <Box sx={{ height: { xs: 40, md: 80 }, width: { xs: 40, md: 80 }}} >
                        {src ? (
                            <Image
                                src={src}
                                alt={card?.title || ''}
                                width={80}
                                height={80}
                                style={{ objectFit: 'contain', width: '100%', height: 'auto' }}
                            />
                        ) : null}
                        </Box>

                        <Typography
                            variant='h3'
                        >
                            {card?.title}
                        </Typography>
                    </Grid>
                )
                })}
            </Grid>
        </RegularSection>
    )
}

export default Index
